import { InstanceScreen } from 'component/navigation/instance';
import { useLocalSearchParams } from 'expo-router';

export default function LoginTokenRedirectScreen() {
    const { provider1, token1 } = useLocalSearchParams<'/[siloKey]/login/one/tokenRedirect'>();
    return <InstanceScreen params={{ provider1, token1 }} screenKey='tokenRedirect' />;
}
